import { useNavigate } from 'react-router-dom';
import { LuBell } from '@platform/icon';
import { NotificationDot } from '@platform/ui';
import { useInquiryUserMenuNotification } from '@/features/inquiry';
import { PATHS } from '@/shared/constants/app/routes.constant.ts';

interface NotificationBellProps {
  className?: string;
}

/**
 * 헤더 종 알림 버튼.
 * 현재 알림 소스는 1:1 문의 미확인 답변 여부(boolean) 하나뿐이라 추후 고도화 예정
 */
export function NotificationBell({ className = '' }: NotificationBellProps) {
  const navigate = useNavigate();
  const { data: hasUnread = false } = useInquiryUserMenuNotification();

  return (
    <button
      type="button"
      onClick={() => navigate(PATHS.SUPPORT_INQUIRIES)}
      aria-label={hasUnread ? '알림 있음 — 1:1 문의 확인' : '알림'}
      title="알림"
      className={`relative grid h-10 w-10 place-items-center rounded-full text-neutral-950/70 transition-colors hover:bg-black/[0.05] dark:text-white/70 dark:hover:bg-white/10 ${className}`}
    >
      <LuBell className="h-[18px] w-[18px]" aria-hidden />
      {hasUnread ? (
        <span className="absolute right-2 top-2">
          <NotificationDot color="var(--color-red-500)" size={7} />
        </span>
      ) : null}
    </button>
  );
}
